export const STATE_INIT = "initiating"
export const STATE_HANDLE = "handling"
export const STATE_EXEC = "executing"
export const STATE_CHECK = "checking"
export const STATE_DONE = "done"
